export {
    agentNotesSearchSchema,
    type AgentNotesTab,
} from '@apps/web/features/admin_agent_notes/model/search_params';
export { AgentNotesPage } from '@apps/web/features/admin_agent_notes/ui/agent_notes_page';
export { NoteDetailPage } from '@apps/web/features/admin_agent_notes/ui/note_detail_page';
